// disabilito quest components per motivi di sicurezza (danno accesso a dati sensibili)
// import PlaygroundReport from '@/views/Playground/report/PlaygroundReport.vue'
// import PlaygroundDocuments from '@/views/Playground/documents/PlaygroundDocuments.vue'

import PlaygroundStateMachine from '@/views/Playground/stateMachine/StateMachine.vue'
import PlaygroundTheme from '@/views/Playground/theme/Theme.vue'
import PlaygroundDashboard from '@/views/Playground/dashboard/PlaygroundDashboard.vue'
import PlaygroundTreeEditorV2 from '@/views/Playground/documents/PlaygroundTreeEditorV2.vue'
import PlaygroundDocumentsV2 from '@/views/Playground/documents/PlaygroundDocumentsV2.vue'
import PlaygroundRecaptcha from '@/views/Playground/recaptcha/PlaygroundRecaptcha.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'Playground',

  created () {
    // Read from router the tool to start
    if (this.$router.history.current?.params?.tool) {
      this.tool = this.tools.find(t => t.path === this.$router.history.current.params.tool)
    }
  },

  computed: {
    ...mapGetters({
      userIsAdmin: 'userDataStore/userIsAdmin'
    })
  },

  data () {
    return {
      tool: null,
      tools: [
        // Define here new tools/prototypes
        { path: 'dashboard', label: 'Dashboard', component: PlaygroundDashboard },
        { path: 'documentsV2', label: 'DocumentsV2', component: PlaygroundDocumentsV2 },
        { path: 'treeEditorV2', label: 'TreeEditorV2', component: PlaygroundTreeEditorV2 },
        { path: 'stateMachine', label: 'State Machine', component: PlaygroundStateMachine },
        { path: 'theme', label: 'Theme', component: PlaygroundTheme },
        { path: 'recaptcha', label: 'reCAPTCHA', description: 'Test Google reCAPTCHA v3 integration', component: PlaygroundRecaptcha }
      ]
    }
  },
  // { path: 'documents', label: 'Documents', component: PlaygroundDocuments },
  // { path: 'report', label: 'Report', component: PlaygroundReport },

  methods: {
    openTool (tool) {
      this.$router.agilis.playground(tool.path) // no need to update the tool, router will remount the component properly
    }
  }
}
